import { IUser } from 'types/user';

/**
 * Czy konto może się normalnie logować (nie zablokowane przez Devise).
 * Jedno źródło: `user.locked_at` z `UserSerializer` — blokada jest na modelu User, nie Profile.
 */
export function isUserAccountActive(user: IUser | undefined): boolean {
  if (!user) return true;
  return !user.locked_at;
}
